export const CMS_AUTH_START = "CMS_AUTH_START";
export const CMS_AUTH_SUCCESS = "CMS_AUTH_SUCCESS";
export const CMS_AUTH_FAILED = "CMS_AUTH_FAILED";
export const CMS_AUTH_LOGOUT = "CMS_AUTH_LOGOUT";

// DASHBOARD
export const DASHBOARD_DATAS_START = "DASHBOARD_DATAS_START";
export const DASHBOARD_DATAS_SUCCESS = "DASHBOARD_DATAS_SUCCESS";
export const DASHBOARD_DATAS_FAILED = "DASHBOARD_DATAS_FAILED";

export const FILTER_DASHBOARD_START = "FILTER_DASHBOARD_START";
export const FILTER_DASHBOARD_SUCCESS = "FILTER_DASHBOARD_SUCCESS";
export const FILTER_DASHBOARD_RESET = "FILTER_DASHBOARD_RESET";

// TRANSACTIONS
export const FETCH_TRANSACTIONS_START = "FETCH_TRANSACTIONS_START";
export const FETCH_TRANSACTIONS_SUCCESS = "FETCH_TRANSACTIONS_SUCCESS";
export const FETCH_TRANSACTIONS_FAILED = "FETCH_TRANSACTIONS_FAILED";

export const FILTER_TRANSACTIONS_START = "FILTER_TRANSACTIONS_START";
export const FILTER_TRANSACTIONS_SUCCESS = "FILTER_TRANSACTIONS_SUCCESS";
export const FILTER_TRANSACTIONS_RESET = "FILTER_TRANSACTIONS_RESET";

export const FETCH_TRANSACTION_START = "FETCH_TRANSACTION_START";
export const FETCH_TRANSACTION_SUCCESS = "FETCH_TRANSACTION_SUCCESS";
export const FETCH_TRANSACTION_FAILED = "FETCH_TRANSACTION_FAILED";

export const FETCH_REJECT_REMARKS_START = "FETCH_REJECT_REMARKS_START";
export const FETCH_REJECT_REMARKS_SUCCESS = "FETCH_REJECT_REMARKS_SUCCESS";
export const FETCH_REJECT_REMARKS_FAILED = "FETCH_REJECT_REMARKS_FAILED";

export const FETCH_PRODUCTS_START = "FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILED = "FETCH_PRODUCTS_FAILED";

export const FETCH_SKU_START = "FETCH_SKU_START";
export const FETCH_SKU_SUCCESS = "FETCH_SKU_SUCCESS";
export const FETCH_SKU_FAILED = "FETCH_SKU_FAILED";

export const FETCH_STORES_START = "FETCH_STORES_START";
export const FETCH_STORES_SUCCESS = "FETCH_STORES_SUCCESS";
export const FETCH_STORES_FAILED = "FETCH_STORES_FAILED";

export const APPROVE_RECEIPT_START = "APPROVE_RECEIPT_START";
export const APPROVE_RECEIPT_SUCCESS = "APPROVE_RECEIPT_SUCCESS";
export const APPROVE_RECEIPT_FAILED = "APPROVE_RECEIPT_FAILED";

export const REJECT_RECEIPT_START = "REJECT_RECEIPT_START";
export const REJECT_RECEIPT_SUCCESS = "REJECT_RECEIPT_SUCCESS";
export const REJECT_RECEIPT_FAILED = "REJECT_RECEIPT_FAILED";

export const REANALYZE_RECEIPT_START = "REANALYZE_RECEIPT_START";
export const REANALYZE_RECEIPT_SUCCESS = "REANALYZE_RECEIPT_SUCCESS";
export const REANALYZE_RECEIPT_FAILED = "REANALYZE_RECEIPT_FAILED";

// CUSTOMERS
export const FETCH_CUSTOMERS_START = "FETCH_CUSTOMERS_START";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAILED = "FETCH_CUSTOMERS_FAILED";

export const FILTER_CUSTOMERS_START = "FILTER_CUSTOMERS_START";
export const FILTER_CUSTOMERS_SUCCESS = "FILTER_CUSTOMERS_SUCCESS";
export const FILTER_CUSTOMERS_RESET = "FILTER_CUSTOMERS_RESET";

export const FETCH_CUSTOMER_START = "FETCH_CUSTOMER_START";
export const FETCH_CUSTOMER_SUCCESS = "FETCH_CUSTOMER_SUCCESS";
export const FETCH_CUSTOMER_FAILED = "FETCH_CUSTOMER_FAILED";

export const FETCH_BRANCHES_START = "FETCH_BRANCHES_START";
export const FETCH_BRANCHES_SUCCESS = "FETCH_BRANCHES_SUCCESS";
export const FETCH_BRANCHES_FAILED = "FETCH_BRANCHES_FAILED";

export const DISCARD_TRANSACTION_START = "DISCARD_TRANSACTION_START";
export const DISCARD_TRANSACTION_SUCCESS = "DISCARD_TRANSACTION_SUCCESS";
export const DISCARD_TRANSACTION_FAILED = "DISCARD_TRANSACTION_FAILED";

export const ADD_STORE_START = "ADD_STORE_START";
export const ADD_STORE_SUCCESS = "ADD_STORE_SUCCESS";
export const ADD_STORE_FAILED = "ADD_STORE_FAILED";

export const ADD_BRANCH_START = "ADD_BRANCH_START";
export const ADD_BRANCH_SUCCESS = "ADD_BRANCH_SUCCESS";
export const ADD_BRANCH_FAILED = "ADD_BRANCH_FAILED";

export const EDIT_TRANSACTION_START = "EDIT_TRANSACTION_START";
export const EDIT_TRANSACTION_SUCCESS = "EDIT_TRANSACTION_SUCCESS";
export const EDIT_TRANSACTION_FAILED = "EDIT_TRANSACTION_FAILED";

export const RESEND_COUPON_START = "RESEND_COUPON_START";
export const RESEND_COUPON_SUCCESS = "RESEND_COUPON_SUCCESS";
export const RESEND_COUPON_FAILED = "RESEND_COUPON_FAILED";

export const FRAUD_DETECT_START = "FRAUD_DETECT_START";
export const FRAUD_DETECT_SUCCESS = "FRAUD_DETECT_SUCCESS";
export const FRAUD_DETECT_FAILED = "FRAUD_DETECT_FAILED";

export const RESET_ACTION_MESSAGE_SUCCESS = "RESET_ACTION_MESSAGE_SUCCESS";

// FILE EXPORT
export const FILE_EXPORT_SUCCESS = "FILE_EXPORT_SUCCESS";

// REDEEM
export const FETCH_REDEEMS_START = "FETCH_REDEEMS_START";
export const FETCH_REDEEMS_SUCCESS = "FETCH_REDEEMS_SUCCESS";
export const FETCH_REDEEMS_FAILED = "FETCH_REDEEMS_FAILED";

export const FILTER_REDEEMS_START = "FILTER_REDEEMS_START";
export const FILTER_REDEEMS_SUCCESS = "FILTER_REDEEMS_SUCCESS";
export const FILTER_REDEEMS_FAILED = "FILTER_TREDEEMS_FAILED";

// RAFFLE & WINNERS
export const FILTER_WINNERS_START = "FILTER_WINNERS_START";
export const FILTER_WINNERS_SUCCESS = "FILTER_WINNERS_SUCCESS";
export const FILTER_WINNERS_FAILED = "FILTER_WINNERS_FAILED";

export const RAFFLE_DRAW_START = "RAFFLE_DRAW_START";
export const RAFFLE_DRAW_SUCCESS = "RAFFLE_DRAW_SUCCESS";
export const RAFFLE_DRAW_FAILED = "RAFFLE_DRAW_FAILED";

export const SAVE_WINNERS_START = "SAVE_WINNERS_START";
export const SAVE_WINNERS_SUCCESS = "SAVE_WINNERS_SUCCESS";
export const SAVE_WINNERS_FAILED = "SAVE_WINNERS_FAILED";

export const FETCH_WINNERS_START = "FETCH_WINNERS_START";
export const FETCH_WINNERS_SUCCESS = "FETCH_WINNERS_SUCCESS";
export const FETCH_WINNERS_FAILED = "FETCH_WINNERS_FAILED";

export const OFFICIAL_WINNER_START = "OFFICIAL_WINNER_START";
export const OFFICIAL_WINNER_SUCCESS = "OFFICIAL_WINNER_SUCCESS";
export const OFFICIAL_WINNER_FAILED = "OFFICIAL_WINNER_FAILED";

export const SEARCH_ENTRIES_START = "SEARCH_ENTRIES_START";
export const SEARCH_ENTRIES_SUCCESS = "SEARCH_ENTRIES_SUCCESS";
export const SEARCH_ENTRIES_FAILED = "SEARCH_ENTRIES_FAILED";

export const RESET_ENTRIES_WINNERS = "RESET_ENTRIES_WINNERS";
export const RESET_ACTION_SUCCESS_MESSAGE = "RESET_ACTION_SUCCESS_MESSAGE";

// ADS
export const FETCH_ADS_START = "FETCH_ADS_START";
export const FETCH_ADS_SUCCESS = "FETCH_ADS_SUCCESS";
export const FETCH_ADS_FAILED = "FETCH_ADS_FAILED";

export const FILTER_ADS_START = "FILTER_ADS_START";
export const FILTER_ADS_SUCCESS = "FILTER_ADS_SUCCESS";
export const FILTER_ADS_RESET = "FILTER_ADS_RESET";